export default __webpack_public_path__ + "static/media/maintenance.a68ffd76.jpg";